import { PackageSchemaTypeEnum } from '../domain';
import {
  CreatePackageReleaseBody,
  CreatePackageFromJsonBody,
  CreatePackageByVersionBody,
} from './body';
import {
  PackageParamUniversal,
  CreateReleaseParams,
  GetPackagesQueryFilter,
  PackageIncludesParams,
} from './param';
import { z } from 'zod';
import { packageLevel, packageStatus } from './propTransformer';

export const CreateReleaseUnion = z.intersection(
  CreatePackageReleaseBody,
  CreateReleaseParams,
);
export const CreatePackageFromJsonUnion = z.intersection(
  PackageParamUniversal,
  CreatePackageFromJsonBody,
);

export const StatusDetailsReleaseParam = z.object({
  statusDetailsReleaseData: z.object({
    status: packageStatus,
    level: packageLevel,
  }),
  schemaType: z.nativeEnum(PackageSchemaTypeEnum),
});

export const CreatePackageByVersionUnion = z.intersection(
  z.intersection(PackageParamUniversal, CreatePackageByVersionBody),
  StatusDetailsReleaseParam,
);

export const GetPackageByIdQueryUnion = z.intersection(
  GetPackagesQueryFilter,
  PackageIncludesParams,
);
